export default __webpack_public_path__ + "static/media/snow1.5a11bead.png";